import { useContext } from "react";

import type { AuthContextValue } from "@/features/auth/shared/auth-context-value";

import { AuthContext } from "@/features/auth/shared/auth-context-value";

/** Split from `auth-context.tsx` — a `.tsx` file may only export PascalCase component identifiers (see `naming.test.ts`), and `useAuth` is a hook. */
export function useAuth(): AuthContextValue {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
}
